let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("6wr18"), load("ffEVr"), load("kMc37")]).then(() => parcelRequire('95OKa'));